import { normalizeNotificationActionHref } from "./rejectionNotification";

export const HIRING_INVITES_COMPLETED_TYPE = "hiring.invites.completed";

export function isHiringInvitesCompletedNotification(notification) {
  return String(notification?.type || "").trim() === HIRING_INVITES_COMPLETED_TYPE;
}

/**
 * Bell + list copy for hiring.invites.completed — job title primary, counts secondary.
 * @param {{ title?: string, body?: string, payload?: { jobTitle?: string, sent?: number, failed?: number } } | null | undefined} notification
 */
export function getHiringInvitesCompletedListDisplay(notification) {
  const payload = notification?.payload && typeof notification.payload === "object" ? notification.payload : {};
  let jobTitle = String(payload.jobTitle || "").trim();
  let sent = Number(payload.sent);
  let failed = Number(payload.failed);

  if (!Number.isFinite(sent)) sent = 0;
  if (!Number.isFinite(failed)) failed = 0;

  const body = String(notification?.body || "").trim();
  if (!jobTitle && body) {
    const failedMatch = body.match(/^(\d+) sent · (\d+) failed for (.+)$/);
    if (failedMatch) {
      sent = Number(failedMatch[1]) || sent;
      failed = Number(failedMatch[2]) || failed;
      jobTitle = String(failedMatch[3] || "").trim();
    } else {
      const sentMatch = body.match(/^(\d+) sent for (.+)$/);
      if (sentMatch) {
        sent = Number(sentMatch[1]) || sent;
        jobTitle = String(sentMatch[2] || "").trim();
      }
    }
  }

  let subtitle = "";
  if (failed > 0) {
    subtitle = `${sent} sent · ${failed} failed`;
  } else if (sent === 1) {
    subtitle = "1 invite sent";
  } else if (sent > 0) {
    subtitle = `${sent} invites sent`;
  } else {
    subtitle = "Invites finished";
  }

  return {
    kicker: "Invites",
    heading: jobTitle || "Your role",
    subtitle,
  };
}

/** Bell dropdown + notifications page row tap for invite batch completion. */
export function hiringInvitesCompletedOpenPath(notification, role) {
  const jobPostId = String(notification?.payload?.jobPostId || "").trim();
  if (jobPostId) {
    return `/hiring/roles/${encodeURIComponent(jobPostId)}?tab=invites`;
  }
  return normalizeNotificationActionHref(notification?.actionHref, role);
}
